import HelpIcon from "@mui/icons-material/Help";
import Tooltip from "@mui/material/Tooltip";
import { useTranslation } from "react-i18next";
import Currency from "../../general/Currency";
import { useTicket } from "../../../store/Store";
import { isCloud9 } from "../../surcharge/api";

const Surcharge = ({ key, surcharge, summary = false }) => {
  const { t } = useTranslation();
  const { data: ticketData } = useTicket();
  const tooltipKey = isCloud9(ticketData)
    ? "surcharge.tooltipCloud9"
    : "surcharge.tooltip";

  return (
    <div className="flex justify-between items-center py-1.5" key={key}>
      <span className={`inline-flex items-center ${summary ? "text-gray-600" : ""}`}>
        {surcharge.label}
        {!surcharge.id && (
          <span className="ml-2">
            <Tooltip
              title={t(tooltipKey)}
              arrow
              placement="top"
              className="flex-1"
            >
              <HelpIcon className="text-primary text-sm" />
            </Tooltip>
          </span>
        )}
      </span>
      <span className={{"font-medium text-gray-600": surcharge.id, "text-xs text-gray-600": !surcharge.id}}>
        <Currency value={surcharge?.amount} />
      </span>
    </div>
  );
};

export default Surcharge;
